/* eslint-env jquery */
const $ = jQuery;
if ($('.steps').length) {
  $(document).ready(stepsInit);
  $(window).on('resize', stepsMatchHeight('steps', 0));
}

function stepsInit() {
  stepsClick('steps');
  stepsMatchHeight('steps', 0);
}

export function stepsClick(divClass) {
  $(`.${divClass} .steps-list li`).click(function () {
    $(`.${divClass} .steps-list li`).removeClass('active');
    $(this).addClass('active');
    if ($(`.${divClass} .steps-list li`).hasClass('active')) {
      $(`.${divClass} .steps-image li`).removeClass('active');
      $(`.${divClass} .steps-image li`).eq($(this).index()).addClass('active');
      $(`.${divClass} .steps-image li`)
        .eq($(this).index() + 1)
        .removeClass('active');
    }
  });
}

export function stepsMatchHeight(divClass, childNode) {
  const imageHeight = $('.steps-image li:first-child img').height();
  $(`.${divClass} .steps-image li`).each(function () {
    const image = $(this)[0].childNodes[`${childNode}`];
    $(image).css('height', `${imageHeight}px`);
    $(`.${divClass} .steps-image`).css('height', `${imageHeight}px`);
  });
}

export default { stepsInit, stepsMatchHeight };
